"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SentryErrorService_instances, _SentryErrorService_getDummySpan;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryErrorService = exports.CONTEXT_FINGERPRINT = exports.Span = exports.InternalAttributes = void 0;
const feature_1 = require("@thesisedu/feature");
const feature_utils_1 = require("@thesisedu/feature-utils");
const Span_1 = require("./Span");
const log_1 = require("./log");
var Span_2 = require("./Span");
Object.defineProperty(exports, "InternalAttributes", { enumerable: true, get: function () { return Span_2.InternalAttributes; } });
Object.defineProperty(exports, "Span", { enumerable: true, get: function () { return Span_2.Span; } });
/** The Sentry fingerprint context key. */
exports.CONTEXT_FINGERPRINT = 'sentry:fingerprint';
/**
 * A Sentry-specific implementation of the {@link @thesisedu/feature#ErrorService}
 */
class SentryErrorService extends feature_1.ErrorService {
    constructor(root, options, appOptions, client) {
        var _a;
        super(root);
        _SentryErrorService_instances.add(this);
        this.client = client;
        this.options = options;
        this.appOptions = appOptions;
        this.isEnabled = !!this.options.dsn;
        if (this.isEnabled) {
            (0, log_1.debug)('sentry is enabled');
            this.client.init(Object.assign(Object.assign({ dsn: this.options.dsn, release: (_a = this.appOptions.release) !== null && _a !== void 0 ? _a : 'development', environment: this.options.environment, maxBreadcrumbs: 100, normalizeDepth: 6 }, this.options.additionalOptions), { beforeSend: (event, hint) => {
                    var _a, _b;
                    if ((_a = event.extra) === null || _a === void 0 ? void 0 : _a[exports.CONTEXT_FINGERPRINT]) {
                        (0, log_1.debug)('setting fingerprint to %O', event.extra[exports.CONTEXT_FINGERPRINT]);
                        event.fingerprint = event.extra[exports.CONTEXT_FINGERPRINT];
                    }
                    // Ignore any errors with a stacktrace that starts with "blob:" - we typically
                    // can't do anything with those.
                    if (this.isBlobStacktrace(event))
                        return null;
                    if ((_b = this.options.additionalOptions) === null || _b === void 0 ? void 0 : _b.beforeSend) {
                        return this.options.additionalOptions.beforeSend(event, hint);
                    }
                    return event;
                } }));
            (0, feature_1.addLogListener)('feature-sentry-core', (level, args) => {
                if (level === feature_1.LogLevel.Debug) {
                    try {
                        this.leaveBreadcrumb(feature_utils_1.Format.sprintf(args[0], ...args.slice(1)), this.mapLogLevel(level));
                    }
                    catch (err) {
                        console.warn('error logging breadcrumb %O; args %O', err, args);
                    }
                }
            }, feature_1.LogListenerMode.AllDebugWithoutColors);
        }
    }
    isBlobStacktrace(event) {
        var _a, _b, _c, _d;
        const errors = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values;
        if ((errors === null || errors === void 0 ? void 0 : errors.length) === 1 && ((_c = (_b = errors[0].stacktrace) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length) === 1) {
            const frame = errors[0].stacktrace.frames[0];
            if ((_d = frame.filename) === null || _d === void 0 ? void 0 : _d.startsWith('blob:')) {
                return true;
            }
        }
        return false;
    }
    /** {@inheritDoc @thesisedu/feature#ErrorService.clearUserContext} */
    clearUserContext() {
        if (!this.isEnabled)
            return;
        (0, log_1.debug)('clearing user context');
        this.client.setUser(null);
    }
    /** {@inheritDoc @thesisedu/feature#ErrorService.setContext} */
    setContext(key, value) {
        (0, log_1.debug)('updating context inside hub %s -> %O', key, value);
        this.client.setContext(key, value);
    }
    /**
     * An internal method to map a {@link @thesisedu/feature#LogLevel} to a Sentry severity level.
     * @param level - the LogLevel
     * @internal
     */
    mapLogLevel(level) {
        switch (level) {
            case feature_1.LogLevel.Debug:
                return feature_1.SeverityLevel.Debug;
            case feature_1.LogLevel.Warning:
                return feature_1.SeverityLevel.Warning;
            case feature_1.LogLevel.Error:
                return feature_1.SeverityLevel.Error;
        }
    }
    /**
     * An internal method to map a Sentry severity label to a {@link @thesisedu/feature#LogLevel}.
     * @param level - the SeverityLevel
     * @internal
     */
    mapSentryLevel(level) {
        switch (level) {
            case feature_1.SeverityLevel.Debug:
                return 'debug';
            case feature_1.SeverityLevel.Warning:
                return 'warning';
            case feature_1.SeverityLevel.Error:
                return 'error';
        }
    }
    /** {@inheritDoc @thesisedu/feature#ErrorService.leaveBreadcrumb} */
    leaveBreadcrumb(message, level, data, category) {
        if (!this.isEnabled)
            return;
        this.client.addBreadcrumb({
            message,
            level: this.mapSentryLevel(level),
            data,
            category: category !== null && category !== void 0 ? category : 'console',
        });
    }
    /** {@inheritDoc @thesisedu/feature#ErrorService.reportError} */
    reportError(error, context) {
        if (!this.isEnabled)
            return;
        (0, log_1.debug)('reporting error');
        (0, log_1.debug)(error);
        this.client.withScope(scope => {
            if (context) {
                (0, log_1.debug)('setting context');
                (0, log_1.debug)(context);
                scope.setExtras(context);
            }
            if (error instanceof Error) {
                (0, log_1.debug)('capturing exception');
                this.client.captureException(error);
            }
            else {
                (0, log_1.debug)('capturing message');
                this.client.captureMessage(error, 'error');
            }
        });
    }
    /** {@inheritDoc @thesisedu/feature#ErrorService.setUserContext} */
    _setUserContext(user) {
        const userContext = { id: user.id, group: user.group };
        if (this.isEnabled) {
            (0, log_1.debug)('setting user context %O', user);
            this.client.setUser(userContext);
        }
        return userContext;
    }
    /** {@inheritDoc @thesisedu/feature#ErrorService.sync} */
    sync() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    getCurrentScope() {
        return this.client.getCurrentScope();
    }
    getCurrentSpan() {
        const span = this.client.getActiveSpan();
        return span ? Span_1.Span.wrap(span) : undefined;
    }
    _optsToStartSpanOptions({ name, op, origin }) {
        return {
            name,
            op,
            origin: origin ? `manual.${origin}` : undefined,
        };
    }
    span(opts, callback) {
        const { autoEnd = true } = opts;
        const fn = autoEnd ? 'startSpan' : 'startSpanManual';
        return this.client[fn](this._optsToStartSpanOptions(opts), sentrySpan => {
            if (sentrySpan) {
                const ourSpan = Span_1.Span.wrap(sentrySpan);
                ourSpan.setInternalAttributes(opts);
                return callback(ourSpan);
            }
            else {
                if (process.env.NODE_ENV !== 'development' &&
                    process.env.NODE_ENV !== 'test' &&
                    process.env.NODE_ENV !== 'e2e' &&
                    !process.env.CI) {
                    (0, log_1.debug)('could not find sentry span inside #span(); using a dummy span instead');
                }
                return callback(__classPrivateFieldGet(this, _SentryErrorService_instances, "m", _SentryErrorService_getDummySpan).call(this));
            }
        });
    }
    startSpan(opts) {
        const sentrySpan = this.client.startInactiveSpan(this._optsToStartSpanOptions(opts));
        if (sentrySpan) {
            const ourSpan = Span_1.Span.wrap(sentrySpan);
            ourSpan.setInternalAttributes(opts);
            return ourSpan;
        }
        else {
            if (process.env.NODE_ENV !== 'development' &&
                process.env.NODE_ENV !== 'test' &&
                process.env.NODE_ENV !== 'e2e' &&
                !process.env.CI) {
                (0, log_1.debug)('could not find sentry span inside #startSpan(); using a dummy span instead');
            }
            return __classPrivateFieldGet(this, _SentryErrorService_instances, "m", _SentryErrorService_getDummySpan).call(this);
        }
    }
}
exports.SentryErrorService = SentryErrorService;
_SentryErrorService_instances = new WeakSet(), _SentryErrorService_getDummySpan = function _SentryErrorService_getDummySpan() {
    return {
        end: () => { },
        getAttribute: key => undefined,
        setAttribute: () => { },
        getSampled: () => false,
        setSampled: () => { },
    };
};
//# sourceMappingURL=index.js.map